import * as React from 'react'

import { selectionIncludesProjectLocation } from '~/client/src/shared/components/ResourceControls/controlKeys'

import { useResource } from '../context'

/**
 * Whether the current selection contains the project's site root - the one row the bulk
 * actions must not touch.
 *
 * Scans `state.records` rather than `filteredRecords`: the selection is never pruned when a
 * filter changes, so a site root scrolled out of view is still in `selectedIds` and still in
 * the id list every bulk handler passes on.
 *
 * Inert for every resource type but Locations, which is what keeps the same two Objects-tab
 * buttons unaffected on Equipment, Materials and StruxTags.
 */
export function useSelectionHasProjectLocation(): boolean {
  const {
    state: { records, selectedIds },
    meta: { resourceTypeId },
  } = useResource()

  return React.useMemo(
    () =>
      selectionIncludesProjectLocation(resourceTypeId, records, selectedIds),
    [resourceTypeId, records, selectedIds],
  )
}
